import NicknameBar from '../components/NicknameBar';
import TeamBadge from '../components/TeamBadge';
import { TEAM_SHORT_NAMES } from '../components/teamTheme';

type TeamColor = 'BLUE' | 'RED' | 'GREEN' | 'YELLOW';

interface PollPrepareScreenProps {
  targetTeam: TeamColor | null;
  isMyTeam: boolean;
}

function PollPrepareScreen({ targetTeam, isMyTeam }: PollPrepareScreenProps) {
  if (isMyTeam || targetTeam === null) {
    // La mia squadra o tutti
    return (
      <div className="flex items-center justify-center min-h-screen p-4 pt-10">
        <NicknameBar />
        <div className="text-center">
          <p className="text-6xl font-heading font-bold text-ink mb-4 animate-pulse">
            Prepararsi al voto!
          </p>
          {targetTeam && (
            <div className="mt-4">
              <TeamBadge teamColor={targetTeam} size="lg" />
            </div>
          )}
        </div>
      </div>
    );
  }

  // Non è la mia squadra
  return (
    <div className="flex items-center justify-center min-h-screen p-4 pt-10">
      <NicknameBar />
      <div className="text-center">
        <p className="text-3xl text-ink-light">
          In attesa di un voto dalla Squadra {TEAM_SHORT_NAMES[targetTeam]}
        </p>
      </div>
    </div>
  );
}

export default PollPrepareScreen;
